// src/apollo/hooks-team.ts
import {useQuery, useMutation, ApolloError, Reference, ApolloCache, InMemoryCache, gql} from '@apollo/client';
import {Team} from './graphql';
import {GET_TEAM, GET_ALL_TEAMS, UPDATE_TEAM} from './queries';
import {MutationUpdateTeamArgs, QueryTeamArgs, TeamInput, TeamResponse} from '~/apollo/generated';

export const useTeam = (teamId: string) => {
    const {data, loading, error} = useQuery<TeamResponse, QueryTeamArgs>(GET_TEAM, {
        variables: {teamId: teamId!},
        skip: !teamId,
    });

    return {
        team: data?.team,
        loading,
        error: error as ApolloError | undefined,
    };
};

export const useUpdateTeam = () => {
    const [updateTeamMutation, { data, loading, error }] = useMutation<
        TeamResponse,
        { id: string; input: TeamInput }
    >(UPDATE_TEAM);

    const updateTeam = async (id: string, input: TeamInput): Promise<Team | null> => {
        try {
            const result = await updateTeamMutation({ variables: { id, input } });
            return result.data?.team || null;
        } catch (err) {
            console.error('Error updating team:', err);
            return null;
        }
    };

    return {
        updateTeam,
        loading,
        error: error as ApolloError | undefined,
        updatedTeam: data?.team,
        errors: data?.errors,
    };
};